module.exports = __webpack_public_path__ + "media/images/ico_search-c60da7bd5e0564e78737d9daf572ab09.png";